import { render, staticRenderFns } from "./gmxkzTx.vue?vue&type=template&id=a8141fce&scoped=true&"
import script from "./gmxkzTx.vue?vue&type=script&lang=js&"
export * from "./gmxkzTx.vue?vue&type=script&lang=js&"
import style0 from "./gmxkzTx.vue?vue&type=style&index=0&id=a8141fce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8141fce",
  null
  
)

export default component.exports